import React from 'react'

const AddPricingStrategy = () => {
  return (
    <div>AddPricingStrategy-cancel</div>
  )
}

export default AddPricingStrategy